// Localhost
// export const BASE_URL = "http://localhost:8000";
// export const API_URL = BASE_URL + "/api";

// production
export const BASE_URL = "https://aic.kz";
export const API_URL = BASE_URL + "/api";
